import React from "react";

function BS4_Tables() {
  return (
    <div>
      <h1>BS4_Tables Component</h1>
      <p>This is the BS4_Tables tutorial page content.</p>
    </div>
  );
}

export default BS4_Tables;
